import {
  Col1,
  Title1,
  Title2,
  Section,
  Col2,
} from "@/components/licence-guide";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}

export default function LicenceGuide() {
  return (
    <>
      <Head>
        <link rel="icon" href="/cup-favicon.ico" />
        <style>{`body {background-color:black;}`}</style>
      </Head>
      <div className="text-white pt-[160px] container mx-auto 2xl:w-[1440px]">
        <div className="font-DIN_Alternate text-center">
          <div className="text-[48px] font-bold mb-[16px]">Licence Terms</div>
          <div className="text-[18px]">Version 8/8/22</div>
        </div>
        <div className="flex mt-[94px]">
          <Col1>
            <Title1>1. Licence and Licence Rights</Title1>

            <Title2>Stage 0 (before purchase)</Title2>
            <Section>
              (a) Smart Contract Licence Right: A right that the Smart Contract
              Licence (as defined below) will be granted to you once you have
              purchased the Collectible.
              <br />
              The licence with respect to the Smart Contract (the "Smart
              Contract Licence") is a worldwide, limited, personal,
              non-exclusive, transferable, one-time licence to use the Smart
              Contract.
              <br />
              (b) Item Licence Right:
              <br />
              A right that the Item Licence (as defined below) will be granted
              to you once you have revealed the Item via the Smart Contract.
              <br />
              <br />
              The licence with respect to the Item (the "Item Licence") is a
              worldwide, limited, personal, non-exclusive, transferable, licence
              to: <br />
              <div className="pl-[2em]">
                (i) use, copy and display the Item for personal uses and the
                Permitted Commercial Purposes (as defined below); and;
                <br />
                (ii) copy and modify the Item (as modified, the "Modified Item")
                for personal and non-commercial use; and <br />
                (iii) display and perform the Modified Item for personal and
                non-commercial use.
              </div>
            </Section>

            <Title2>Stage 1 (purchase)</Title2>
            <Section>
              (a) Smart Contract Licence: <br />
              After you have purchased the Collectible, we will grant you the
              Smart Contract Licence. <br />
              <br />
              After the automatic operation of the first stage of the Smart
              Contract, the Smart Contract Licence becomes the Smart Contract
              Licence with respect to the second stage of the Smart Contract
              only. <br />
              <br />
              (b) Item Licence Right: <br />
              After you have purchased the Collectible, we will grant you a
              right that the Item Licence will be granted to you once you have
              revealed the Item via the Smart Contract. <br />
            </Section>

            <Title2>Stage 2 (Item revealing)</Title2>
            <Section>
              (a) Smart Contract Licence Terminates <br />
              After the Item revealing, the Smart Contract Licence terminates.
              <br />
              <br />
              (b) Item Licence <br />
              After the Item revealing, we will grant you the Item Licence.
              <br />
            </Section>

            <Title1>2. Licences attached to NFT </Title1>

            <Section>
              The Smart Contract Licence, the Item Licence right, and the Item
              Licence are granted to the owner of the relevant NFT and may only
              be transferred together with the ownership of the NFT. If a
              licencee of the Smart Contract Licence or a licencee of the Item
              Licence or a right holder of the Item Licence right transfers the
              ownership of the relevant NFT to a third party, such Smart
              Contract Licence or Item Licence or Item Licence right will be
              transferred to such third party, and such third party becomes the
              new licencee of the Smart Contract or the new licencee of the Item
              Licence or the new right holder of the Item Licence right.
            </Section>

            <Title1>3. Permitted Commercial Purposes </Title1>

            <Section>
              Pursuant to the terms of the Item Licence, an NFT owner may use
              the underlying Item for the following Permitted Commercial
              Purposes:
            </Section>
          </Col1>
          <Col2 />
        </div>
        <div className="flex">
          <Col1>
            <Section>
              (a) During the period it/he/she owns an NFT, such NFT owner shall
              have the right to use the underlying Item of that NFT to produce,
              sell and advertise certain physical ancillary/accessory products
              (consisting of [stationary, tools, toys, clothes and other small
              products]) bearing the image of such underlying Item (the
              "Ancillary/Accessory Products").
            </Section>
          </Col1>
          <Col2 title="Chinese Version">
            (a) 持有NFT期间，持有人有权使用本NFT制作、销售并宣传实体周边。
          </Col2>
        </div>
        <div className="flex">
          <Col1>
            <Section>
              <div className="pl-[2em]">
                (i) Following the transfer of an NFT by an NFT owner, such NFT
                owner shall not produce, sell and advertise any new
                Ancillary/Accessory Products, however it may continue to sell
                the remaining inventory of the Ancillary/Accessory Products
                within one (1) calendar month following the date of such
                transfer.
                <br />
                (ii) The underlying Item of an NFT printed or replicated on the
                Ancillary/Accessory Products shall be in its original and
                complete form without any form of modification (except for
                resizing or ratio adjusting of such Underlying Item).
                <br />
                (iii) The quality of the Ancillary/[Accessory Products shall
                comply with the relevant laws and regulations, national
                standards, industry standards and/or any other specific
                requirements as requested by any relevant person/entity that
                owns any intellectual property rights of the underlying Item (an
                "IP Owner"). Save for the ownership of the underlying
                intellectual property rights of the Item, these
                Ancillary/Accessory Products (including its production, sale and
                advertisement) are not in any way connected with Base Labs,
                CryptoNatty Pte. Ltd. or any other IP Owner. Any disputes,
                losses and liabilities arising from the Ancillary/Accessory
                Products shall be borne by the relevant NFT owner on its/his/her
                own.
              </div>
            </Section>
          </Col1>
          <Col2>
            (i)
            持有人转让NFT后不得再新增印制实体周边，但是可以在转让后1个自然月内继续销售库存。
            <br />
            <br />
            (ii)
            实体周边上印制或复制的NFT应完整且不经任何修改（等比例调整图像尺寸除外）。
            <br />
            <br />
            (iii)
            实体周边的质量应符合相关法律法规、国家标准、行业标准及/或NFT权利人提出的特别要求（如有），因实体周边产生的一切纠纷、损失及责任均由持有人自行承担。
          </Col2>
        </div>
        <div className="flex">
          <Col1>
            <Section>
              (b) During the period it/he/she owns an NFT, such NFT owner shall
              have the right to use the underlying Item of that NFT for
              commercial purposes on the internet ("Online Commercial Uses").
            </Section>
          </Col1>
          <Col2>
            (b) 持有NFT期间，持有人有权在互联网中以商业目的使用本NFT。
          </Col2>
        </div>
        <div className="flex">
          <Col1>
            <Section>
              <div className="pl-[2em]">
                (i) Following the transfer of an NFT by the NFT owner, such NFT
                owner shall not use the underlying Item of that NFT for any
                Online Commercial Uses.
                <br />
                (ii) The underlying Item of an NFT shall remain in its original
                and complete form without any form of modification (i.e. the
                expression of such underlying Item shall not be modified so to
                become a derivative work, except for (1) resizing or ratio
                adjusting of such underlying Item and (2) using such underlying
                Item in whole or in part without modifying its expression). An
                NFT owner must not use any underlying Item or an NFT to create
                or attempt to create any new cryptographic token by whatever
                means.
                <br />
                (iii) Online Commercial Uses shall comply with the relevant laws
                and regulations, national policies, rules and regulations of
                communication platforms and/or any other specific requirements
                as requested by us, as the owner of the underlying Item and such
                uses will not violate the public interest or public morality of
                the society, and/or the legal rights and interests of a third
                party. Save for the ownership of the underlying intellectual
                property rights of the Item, these Online Commercial Uses are
                not in any way connected with Base Labs, CryptoNatty Pte. Ltd.
                or any other IP Owner. Any disputes, losses and liabilities
                arising from the Online Commercial Uses shall be borne by the
                relevant NFT owner on its/his/her own.
              </div>
            </Section>
          </Col1>
          <Col2>
            (i)
            持有人转让NFT后不得开展新的线上商业使用。除NFT页面另有约定外，线上商业使用不包括单独转让、许可NFT开放的权益。
            <br />
            <br />
            (ii)
            NFT应完整且不经任何修改（即不得改变本NFT表达形成演绎作品，但是等比例调整图像尺寸等在不改动数字藏品表达的情况下全部或部分利用NFT的除外），持有人不得基于本NFT在任何渠道以任何形式生成新的NFT。
            <br />
            <br />
            (iii)
            线上商业使用应符合相关法律法规、国家政策、传播平台规则及/或NFT权利人提出的特别要求（如有），不得有损社会公序良俗或第三方的合法权益，因线上商业使用产生的一切纠纷、损失及责任均由持有人自行承担。
          </Col2>
        </div>

        <div className="flex">
          <Col1>
            <Section>
              ((a) and (b) collectively, the "Permitted Commercial Purposes")
            </Section>

            <Title1>4. Modified Item</Title1>
            <Section>
              (a) For any Modified Item, the person who has modified the Item
              (the "Modifier") will own the copyright in any newly created works
              of authorship created by the Modifier, subject to our ownership of
              the underlying Item and any copyright or other intellectual
              property right therein. To the extent that a Modified Item
              continues to incorporate or include any Item or is otherwise a
              derivative work of any Item, the Modifier shall not use the
              Modified Item other than as expressly authorised in these Terms.
              Other than the copyright of the Modifier as described in the
              preceding sentence, the Modifier will not have, and shall not
              assert or seek to register or obtain, any trademark or other
              intellectual or proprietary right in any Item or Modified Item.
              <br />
              <br />
              (b) You understand that we and our affiliates will continue to
              further modify and develop on any Item and may create works of
              authorship similar or identical to any Modified Item created by
              you. On behalf of yourself and your heirs, successors and assigns,
              you irrevocably and perpetually covenant and agree not to file or
              assert before any court or other government tribunal or authority,
              any claim, counterclaim, demand, action, suit or other proceeding
              alleging or asserting direct or indirect infringement or
              misappropriation of any copyright or other intellectual property
              right that you may have in any Modified Item against:
              <br />
              <br />
              <div className="pl-[2em]">
                (i) us or any of our affiliates or their respective
                shareholders, directors, officers, employees, contractors,
                representatives, agents, licencees, distributors, resellers, or
                business partners;
                <br />
                (ii) any customers of any of the foregoing, or
                <br />
                (iii) any successor or assign of any of the foregoing.
              </div>
            </Section>

            <Title1>5. Prohibition</Title1>
            <Section>
              (a) Paragraphs 1 to 4 above sets forth all of your licences and/or
              licence rights under these Terms with respect to any Smart
              Contract or Item.
              <br />
              <br />
              (b) There are no other licences and/or licence rights, whether
              express or implied, with respect to any Smart Contract, Item,
              Modified Item or any derivative works thereof, and no licences
              and/or licence rights are granted under any patent, trademark,
              trade secret or other intellectual property or proprietary right
              other than any copyright owned or controlled by Base Labs. This is
              true even if exercise of any licence and/or licence right granted
              herein would be prevented, frustrated or impaired without such
              licence and/or licence right.
              <br />
              <br />
              (c) Without limiting the foregoing, the licences or licence rights
              granted herein do not grant you the right to, and you will not
              authorise, permit or assist any third party to:
              <br />
              <br />
              <div className="pl-[2em]">
                (i) grant any sublicence of any of the licences and licence
                rights herein;
                <br />
                (ii) delete, remove or obscure any trademark notice, copyright
                notice or other intellectual property notice in any Smart
                Contract or Item;
              </div>
            </Section>
          </Col1>
          <Col2></Col2>
        </div>
        <div className="flex">
          <Col1>
            <Section>
              <div className="pl-[2em]">
                (iii) whilst using the underlying Item of an NFT for the
                Permitted Commercial Purposes, without the written
                consent/authorisation from Base Labs, CryptoNatty Pte. Ltd.
                and/or the relevant IP owner , (1) through any channel or media
                (including but not limited to its/his/her own media channel)
                refer to, mention or make use of the brand and image of any of
                the aforesaid entities. The brand and image as described herein
                shall include but not limited to the trademarks, trading names,
                brand names and/or logos of each of "Base Labs", "CryptoNatty",
                "Cheers Up", other cooperation partner or the relevant IP owner,
                or (2) indirectly use any brand and image of any of the
                aforesaid entities to carry out any promotion;
              </div>
            </Section>
          </Col1>
          <Col2>
            (iii)
            在商业性使用本NFT时，未经NFT权利人、Baselabs或CryptoNatty书面同意，通过任何渠道或媒体（包括但不限于自媒体等），擅自携带、提及或利用前述主体的品牌字样（包括但不限于Baselabs、CryptoNatty、CheersUP或者其他合作方、权利方的商标、商号、品牌、logo等），或间接利用前述主体的品牌进行推广。
          </Col2>
        </div>

        <div className="flex">
          <Col1>
            <Section>
              <div className="pl-[2em]">
                (iv) exercise any licence and/or licence rights herein to
                create, endorse, support, promote or condone any content,
                material or speech that is defamatory, obscene, pornographic,
                indecent, abusive, offensive, harassing, violent, hateful,
                racist, discriminatory, inflammatory or otherwise objectionable
                or inappropriate as determined by Base Labs at its discretion;
                <br />
                (v) reverse engineer, decompile or attempt to discover the
                source code for any Smart Contract, NFT or Item except to the
                extent that the applicable law permits you to do so
                notwithstanding this prohibition;
                <br />
                (vi) create, sell or attempt to create or sell, fractionalised
                interests in any NFT or Collectible or the licence or licence
                rights granted pursuant to these Terms for any Smart Contract or
                Item;
                <br />
                (vii) separate, unlink or decouple the Item from the relevant
                NFT or Collectible;
                <br />
                (viii) use any Item or Modified Item to create, sell or attempt
                to create or sell any new cryptographic token; or
                <br />
                (ix) use any Item or Modified Item in any manner not expressly
                authorised herein or exercise any licence or licence rights
                herein in any manner that violates the applicable law.
              </div>
            </Section>

            <Title1>6. Base Labs</Title1>
            <Section>
              Base Labs, CryptoNatty Pte. Ltd. and/or any other IP Owner are the
              proprietary owner of all the Smart Contracts and Items. Unless
              specially granted, Base Labs, CryptoNatty Pte. Ltd. and/or any
              other IP Owner retain all right, title and interest in any Smart
              Contract or Item and all copyright or other intellectual property
              rights in any Smart Contract or Item.
            </Section>
          </Col1>
          <Col2></Col2>
        </div>
      </div>
    </>
  );
}
